export class SpecificationQuestionsRequestIds {
  ids: number[];
}
